import Api from '@/api';

export default class Auth {
  isAuthorized() {
    return this.token !== undefined && this.token !== null;
  }

  async authorizeBasedOnIP() {
    try {
      const {data} = await Api.get('authorization').authorizeOnIp();
      this.token = data.token;
    } catch (error) {
      // IP Address not valid
    }
  }

  async login(username, password) {
    try {
      const {data} = await Api.get('authorization').login({
        username,
        password,
      });

      this.token = data.token;

      return true;
    } catch (error) {
      // Invalid username/password
      return false;
    }
  }

  get token() {
    return localStorage.getItem('token');
  }

  set token(token) {
    localStorage.setItem('token', token);
  }
}
